module.exports = __webpack_public_path__ + "static/media/NR.99e49032.png";